document.addEventListener('DOMContentLoaded', function () {
  var obflinks = document.querySelectorAll('.obflink');
  obflinks.forEach(function (el) {
    var navigate = function () {
      var url = atob(el.dataset.o);
      if (el.dataset.target) {
        window.open(url, el.dataset.target);
      } else {
        window.location.href = url;
      }
    };
    el.addEventListener('click', navigate);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        navigate();
      }
    });
  });
});
